<script setup>
const props = defineProps({
    twitter: {
        type: String,
        required: false,
    },
    facebook: {
        type: String,
        required: false,
    },
    linkedin: {
        type: String,
        required: false,
    },
    instagram: {
        type: String,
        required: false,
    },    
    youtube: {
        type: String,
        required: false,
    },    
    bluesky: {
        type: String,
        required: false,
    },
    threads: {
        type: String,
        required: false,
    },
    tiktok: {
        type: String,
        required: false,
    },
    website: {
        type: String,
        required: false,
    },    
    copyToClipboard: {
        type: Boolean,
        default: false,
    },
    link: {
        type: String,
        required: false,
    },
});

const showToast = ref(false);

const hasAnyLink = computed(() => Boolean(
    props.linkedin || props.instagram || props.facebook ||
    props.tiktok || props.youtube || props.bluesky || props.threads ||
    props.twitter || props.website || props.copyToClipboard
));

const copyLinkToClipboard = () => {
    navigator.clipboard.writeText(props.link ? props.link : window.location.href).then(() => {
        showToast.value = true;
        setTimeout(() => {
            showToast.value = false;
        }, 2000);
    });
};
</script>

<template>
    <div v-if="hasAnyLink" class="social-links">
        <ul class="links">
            <li v-if="linkedin" >
                <a :href="linkedin" aria-label="LinkedIn" target="_blank">
                    <MessSvg type="speakers-socials-s-linkedin" />
                    <span class="sr-only">(opens in a new tab)</span>
                </a>
            </li>
            <li v-if="instagram" >
                <a :href="instagram" aria-label="Instagram" target="_blank">
                    <MessSvg type="speakers-socials-s-instagram" />
                    <span class="sr-only">(opens in a new tab)</span>
                </a>
            </li>     
            <li v-if="facebook" >
                <a :href="facebook" aria-label="Facebook" target="_blank">
                    <MessSvg type="speakers-socials-s-facebook" />
                    <span class="sr-only">(opens in a new tab)</span>
                </a>
            </li>
            <li v-if="tiktok">
                <a :href="tiktok" aria-label="TikTok" target="_blank">
                    <MessSvg type="speakers-socials-s-tiktok" />
                    <span class="sr-only">(opens in a new tab)</span>
                </a>
            </li>  
            <li v-if="youtube">
                <a :href="youtube" aria-label="YouTube" target="_blank">
                    <MessSvg type="speakers-socials-s-youtube" />
                    <span class="sr-only">(opens in a new tab)</span>
                </a>
            </li> 
            <li v-if="bluesky">
                <a :href="bluesky" aria-label="BlueSky" target="_blank">
                    <MessSvg type="speakers-socials-s-bluesky" />
                    <span class="sr-only">(opens in a new tab)</span>
                </a>
            </li>   
            <li v-if="threads">
                <a :href="threads" aria-label="Threads" target="_blank">
                    <MessSvg type="speakers-socials-s-threads" />
                    <span class="sr-only">(opens in a new tab)</span>
                </a>
            </li>                                                
            <li v-if="twitter">
                <a :href="twitter" aria-label="X/Twitter" target="_blank">
                    <MessSvg type="speakers-socials-s-x" />
                    <span class="sr-only">(opens in a new tab)</span>
                </a>
            </li>
            <li v-if="website">
                <a :href="website" aria-label="Speaker's Website" target="_blank">
                    <MessSvg type="speakers-socials-s-link" />
                    <span class="sr-only">(opens in a new tab)</span>
                </a>
            </li>            
            <li v-if="copyToClipboard" class="copy-link">
                <button @click="copyLinkToClipboard" aria-label="Copy link to clipboard">
                    <MessSvg type="clipboard" />
                </button>
                <div v-if="showToast" class="toast">Link copied to clipboard!</div>
            </li>
        </ul>
    </div>
</template>

<style lang="scss">
.social-links  {
    display: flex;
    align-items: center;
    gap: 1rem 2.375rem;
    font-weight: 400;
    text-transform: uppercase;
    color: var(--magenta);

    .links {
        display: flex;
        gap: 1rem;

        li {
            cursor: pointer;
            color: var(--magenta);
            margin-bottom: 2.375rem;

            svg {
                transition: 100ms ease;
                width: 2.25rem;
                height: 2.25rem;
            }

            svg path {
                fill: var(--magenta);
            }

            svg circle {
                stroke: var(--magenta);
                fill: transparent;
            }

            &:hover {
                color: var(--magenta);

                svg path {
                    fill: white;
                }

                svg circle {
                    fill: var(--magenta);
                    stroke: var(--magenta);
                }
            }
        }

        .copy-link {
            position: relative;

            .toast {
                position: absolute;
                bottom: 100%;
                left: 50%;
                transform: translateX(-50%);
                background-color: var(--orange-dark);
                color: white;
                padding: 0.5rem 1rem;
                font-size: 14px;
                font-weight: normal;
                text-transform: none;
                opacity: 0;
                animation: fadeInOut 2s ease-in-out;
                white-space: nowrap;
                margin-bottom: 8px;
            }
        }
    }

    @keyframes fadeInOut {
        0% {
            opacity: 0;
            transform: translate(-50%, 10px);
        }

        10% {
            opacity: 1;
            transform: translate(-50%, 0);
        }

        90% {
            opacity: 1;
            transform: translate(-50%, 0);
        }

        100% {
            opacity: 0;
            transform: translate(-50%, 10px);
        }
    }
}
</style>
